module.exports = __webpack_public_path__ + "img/res-2.2c84d5ef.png";